import Vue from 'vue'
import App from './App.vue'
import i18n from './i18n'
import router from './router'
import './registerServiceWorker'

Vue.config.productionTip = false

// Static story pages (scripts/gen-static.js) ship the full text inside #app so
// crawlers see it without running JS. Vue then replaces #app, which would wipe
// the story off the screen -- so read it out of the markup first and hand it to
// App.vue, which restores it on created(). Nothing is duplicated into a JSON
// blob: the DOM we are about to discard IS the source.
function readStaticStory () {
  try {
    const el = document.querySelector('[data-legi-story]')
    if (!el) return null
    const paragraphs = [].slice.call(el.querySelectorAll('.legi-body p'))
      .map(function (p) { return p.textContent.trim() })
      .filter(Boolean)
    if (!paragraphs.length) return null
    return {
      id: el.getAttribute('data-story-id') || '',
      title: el.getAttribute('data-title') || '',
      author: el.getAttribute('data-author') || '',
      audio: el.getAttribute('data-audio') || '',
      lang: el.getAttribute('data-lang') || '',
      readingTime: parseInt(el.getAttribute('data-reading-time'), 10) || null,
      body: paragraphs.join('\n\n')
    }
  } catch (e) {
    return null
  }
}

window.__LEGI_STORY__ = readStaticStory()

new Vue({
  i18n,
  router,
  render: h => h(App)
}).$mount('#app')
